import EventEmitter from 'eventemitter3'
import { getText } from '../prev-locale'

export default (params) => {
  const eventEmitter = new EventEmitter()
  const data = {
    language: params?.language || 'cn',
    selectedMenuKey: null,
  }

  return {
    setData: (key, val) => {
      set(data, key, val)
    },

    setSelectedMenuKey: (menuKey) => {
      data.selectedMenuKey = menuKey
    },
    getSelectedMenuKey: () => data.selectedMenuKey,

    getLanguage: () => data.language,

    setLanguage: (language) => (data.language = language),

    getText: (key, language = data.language) => getText(key, language),

    on: (eventName, callback) => {
      eventEmitter.on(eventName, callback)
    },

    emit: (...args) => {
      eventEmitter.emit(...args)
    },

    off: (...args) => {
      eventEmitter.removeListener(...args)
    },
  }
}
